import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classes from 'classnames';
import apiSettings from '../../../../config/api';
import appConst from '../../../../config/const';
import {validateImages} from '../../../../utils/validationUtils';
import {Button} from "../../../../components/Button";


class UploadImages extends React.Component {
  constructor(props) {
    super(props);
    this.handleDrop = this.handleDrop.bind(this);
    this.createSrcPath = this.createSrcPath.bind(this);
    this.state = {
      error: {},
      images: []
    }
  }

  componentWillMount() {
    this.setState({
      error: this.props.error,
      images: this.props.images
    })
  }

  componentWillReceiveProps(next) {
    this.setState({
      error: next.error,
      images: next.images
    })
  }

  handleDrop(images) {
    const stateImages = [...this.state.images];
    const validate = validateImages(images, stateImages.length);

    if (validate.isValid) {
      this.setState({
        images: stateImages.concat(images).reverse(),
        error: {...this.state.error, images: ''}
      }, () => {
        this.props.onNewImages(this.state.images)
      });
    } else {
      this.setState({error: {...this.state.error, images: validate.error}})
    }
  };

  createSrcPath() {
    const {images} = this.state;
    let src = '/assets/img/noimage.png';
    if (images[0] && images[0].preview) {
      src = images[0].preview;
    }
    if (images[0] && images[0][appConst.PHOTOS.medium] && images[0].updatedAt) {
      src = apiSettings.endpoints.genImageUrl(images[0][appConst.PHOTOS.medium], images[0].updatedAt);
    }
    return src;
  }

  render() {
    const {
      images,
      error,
    } = this.state;

    const className = classes('create-tour__photos-wrap', {activeAdd: images.length > 0});

    return (
      <div className="create-tour__img-main">
        {
          error.images ?
            <span className="error-block">{error.images}</span> : null
        }
        <Dropzone
          className={className}
          accept="image/*"
          onDrop={this.handleDrop}
        >
          {!images.length > 0 ?
            <div className="create-tour__photos-body">
              <i className="fa fa-picture-o" aria-hidden="true" />
              <p>Add photos here</p>
              <p>.png .jpg</p>
            </div> :
            <Button
              iconName="add"
              className="button__icon "
            />
          }
        </Dropzone>
        {images.length > 0 ?
          <img
            src={this.createSrcPath()}
            alt="img"
          /> : null
        }
      </div>
    )
  }
}


UploadImages.propTypes = {
  onNewImages: PropTypes.func,
  images: PropTypes.array,
  error: PropTypes.object
};

export default UploadImages;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/components/UploadImages.js